// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Link } from "@tanstack/react-router";
import { Store } from "lucide-react";
import { cn } from "@/lib/utils";

interface StoreLinkProps {
  storeName: string;
  legibleName?: string;
  className?: string;
  showIcon?: boolean;
}

/**
 * Linked store reference: leading store icon + legible name, pointing to `/stores/$storeName`.
 * Drop-in for the per-cell `<Link>` we used to render in data tables.
 */
export function StoreLink({ storeName, legibleName, className, showIcon = true }: StoreLinkProps) {
  return (
    <Link
      to="/stores/$storeName"
      params={{ storeName }}
      className={cn("inline-flex items-center gap-1.5 text-primary hover:underline", className)}
    >
      {showIcon && <Store className="size-3.5 shrink-0" aria-hidden="true" />}
      <span>{legibleName || storeName}</span>
    </Link>
  );
}
